import styled from 'styled-components';

export const LockStyled = styled.section`
  padding: 64px 0;
  background-color: #212127;

  @media screen and (min-width: 992px) {
    padding: 120px 0;
  }
`;

export const Article = styled.article`
  margin-bottom: 56px;

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 992px) {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: 16px;
    align-items: center;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;

    @media screen and (min-width: 992px) {
      grid-column: 1/13;
    }
  }

  a {
    justify-content: center;

    @media screen and (min-width: 992px) {
      justify-content: flex-start;
    }
  }
`;

export const MainTitle = styled.h1`
  margin: 0 0 40px;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 992px) {
    grid-column: 1/13;
    margin: 0 0 20px;
    font-size: 32px;
    line-height: 1.3;
  }
`;

export const TextBlock = styled.div`
  margin-bottom: 40px;

  @media screen and (min-width: 992px) {
    grid-column: 1/6;
  }
`;

export const TopTag = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;

  @media screen and (min-width: 992px) {
    justify-content: flex-start;
    margin-bottom: 32px;
  }

  img {
    margin-right: 16px;
  }

  h3 {
    display: inline-block;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 1.7;
    text-transform: uppercase;
    color: #ffffff;
  }
`;

export const Title = styled.h2`
  margin: 0 0 24px;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 992px) {
    text-align: left;
  }
`;

export const Description = styled.p`
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 1.7;
  text-align: center;
  color: #d0d2d3;

  @media screen and (min-width: 992px) {
    text-align: left;
  }
`;

export const Figure = styled.figure`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 50px;

  @media screen and (min-width: 992px) {
    grid-column: 7/13;
    margin-top: 0;
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -20%;
    width: 100%;
    padding-top: 100%;
    border-radius: 50%;
    transform: translateY(-50%);
    background: radial-gradient(
      ellipse at center,
      rgba(255, 255, 255, 0.07) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: blur(15px);
    z-index: 0;
  }
`;

export const Graphic = styled.img`
  max-width: 100%;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/EmbeddedLock/styled.js